import { render, staticRenderFns } from "./PetSelectPage.vue?vue&type=template&id=15ef48fb&scoped=true"
import script from "./PetSelectPage.vue?vue&type=script&lang=js"
export * from "./PetSelectPage.vue?vue&type=script&lang=js"
import style0 from "./PetSelectPage.vue?vue&type=style&index=0&id=15ef48fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef48fb",
  null
  
)

export default component.exports